/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseAlarmDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseLeakCountDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseLeakTrendsDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListLeakInsightItem } from '../backend/model';
// @ts-ignore
import type { ApiResponsePaginatedResponseDTOAlarmDTO } from '../backend/model';
/**
 * CouncilAlarmApi - axios parameter creator
 * @export
 */
export const CouncilAlarmApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get all-time leak count for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTimeLeakCount: async (councilId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getAllTimeLeakCount', 'councilId', councilId)
            const localVarPath = `/api/council/council/{councilId}/leaks/all-time-count`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get alarms for a specific council
         * @param {string} councilId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [severity] 
         * @param {string} [type] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAlarms: async (councilId: string, from?: string, to?: string, severity?: string, type?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilAlarms', 'councilId', councilId)
            const localVarPath = `/api/council/council/{councilId}/alarms`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get leak alarm graph data for a specific council
         * @param {string} councilId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeakAlarmGraph: async (councilId: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getLeakAlarmGraph', 'councilId', councilId)
            const localVarPath = `/api/council/council/{councilId}/leak-alarms/graph`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get leak insights for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeakInsights: async (councilId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getLeakInsights', 'councilId', councilId)
            const localVarPath = `/api/council/council/{councilId}/leak-insights`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Update a specific alarm for a council
         * @param {string} councilId 
         * @param {string} alarmId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlarm: async (councilId: string, alarmId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('updateAlarm', 'councilId', councilId)
            // verify required parameter 'alarmId' is not null or undefined
            assertParamExists('updateAlarm', 'alarmId', alarmId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateAlarm', 'body', body)
            const localVarPath = `/api/council/council/{councilId}/alarms/{alarmId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"alarmId"}}`, encodeURIComponent(String(alarmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilAlarmApi - functional programming interface
 * @export
 */
export const CouncilAlarmApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilAlarmApiAxiosParamCreator(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get all-time leak count for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTimeLeakCount(councilId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseLeakCountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTimeLeakCount(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAlarmApi.getAllTimeLeakCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get alarms for a specific council
         * @param {string} councilId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [severity] 
         * @param {string} [type] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilAlarms(councilId: string, from?: string, to?: string, severity?: string, type?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePaginatedResponseDTOAlarmDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilAlarms(councilId, from, to, severity, type, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAlarmApi.getCouncilAlarms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get leak alarm graph data for a specific council
         * @param {string} councilId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeakAlarmGraph(councilId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseLeakTrendsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeakAlarmGraph(councilId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAlarmApi.getLeakAlarmGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get leak insights for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeakInsights(councilId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListLeakInsightItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeakInsights(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAlarmApi.getLeakInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Update a specific alarm for a council
         * @param {string} councilId 
         * @param {string} alarmId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAlarm(councilId: string, alarmId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAlarmDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAlarm(councilId, alarmId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAlarmApi.updateAlarm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilAlarmApi - factory interface
 * @export
 */
export const CouncilAlarmApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilAlarmApiFp(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get all-time leak count for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTimeLeakCount(councilId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseLeakCountDTO> {
            return localVarFp.getAllTimeLeakCount(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get alarms for a specific council
         * @param {string} councilId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [severity] 
         * @param {string} [type] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAlarms(councilId: string, from?: string, to?: string, severity?: string, type?: string, status?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePaginatedResponseDTOAlarmDTO> {
            return localVarFp.getCouncilAlarms(councilId, from, to, severity, type, status, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get leak alarm graph data for a specific council
         * @param {string} councilId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeakAlarmGraph(councilId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseLeakTrendsDTO> {
            return localVarFp.getLeakAlarmGraph(councilId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get leak insights for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeakInsights(councilId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListLeakInsightItem> {
            return localVarFp.getLeakInsights(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Update a specific alarm for a council
         * @param {string} councilId 
         * @param {string} alarmId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlarm(councilId: string, alarmId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAlarmDTO> {
            return localVarFp.updateAlarm(councilId, alarmId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilAlarmApi - object-oriented interface
 * @export
 * @class CouncilAlarmApi
 * @extends {BaseAPI}
 */
export class CouncilAlarmApi extends BaseAPI {
    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get all-time leak count for a specific council
     * @param {string} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAlarmApi
     */
    public getAllTimeLeakCount(councilId: string, options?: RawAxiosRequestConfig) {
        return CouncilAlarmApiFp(this.configuration).getAllTimeLeakCount(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get alarms for a specific council
     * @param {string} councilId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [severity] 
     * @param {string} [type] 
     * @param {string} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAlarmApi
     */
    public getCouncilAlarms(councilId: string, from?: string, to?: string, severity?: string, type?: string, status?: string, options?: RawAxiosRequestConfig) {
        return CouncilAlarmApiFp(this.configuration).getCouncilAlarms(councilId, from, to, severity, type, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get leak alarm graph data for a specific council
     * @param {string} councilId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAlarmApi
     */
    public getLeakAlarmGraph(councilId: string, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return CouncilAlarmApiFp(this.configuration).getLeakAlarmGraph(councilId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get leak insights for a specific council
     * @param {string} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAlarmApi
     */
    public getLeakInsights(councilId: string, options?: RawAxiosRequestConfig) {
        return CouncilAlarmApiFp(this.configuration).getLeakInsights(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Update a specific alarm for a council
     * @param {string} councilId 
     * @param {string} alarmId 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAlarmApi
     */
    public updateAlarm(councilId: string, alarmId: string, body: object, options?: RawAxiosRequestConfig) {
        return CouncilAlarmApiFp(this.configuration).updateAlarm(councilId, alarmId, body, options).then((request) => request(this.axios, this.basePath));
    }
}

